<template>
    <div id="app">

        <ul class="info-holder">
            <li>Active chapter: {{activeChapterIndex}}</li>
            <li>Active step: {{activeStepIndex}}</li>
            <li>Total number of chapters: {{ totalChapters }}</li>
            <li>Total number of steps: {{ totalSteps }}</li>
        </ul>

        <div class="content-holder">
            <div class="content">

                <transition :name="transitionType">
                    <component class="component" :is="activeStep.component" @goToStepCalled="goToStep" />
                </transition>

                <transition name="slidedown">
                    <ul class="subnav" v-if="activeChapterIndex === 4 && (activeStepIndex > 1 && activeStepIndex < 6)">
                        <li :class="{'active': activeStepIndex === 2}" @click="goToStep(4,2)">VoLTE</li>
                        <li :class="{'active': activeStepIndex === 3}" @click="goToStep(4,3)">3X Non-Standalone</li>
                        <li :class="{'active': activeStepIndex === 4}" @click="goToStep(4,4)">Option 2: Standalone with EPS fallback</li>
                        <li :class="{'active': activeStepIndex === 5}" @click="goToStep(4,5)">Option 2: Standalone with VoNR</li>
                    </ul>
                </transition>

                <div class="navbar">

                    <ul class="navigation-buttons">
                        <li @click="goToStep(1, 1)" :class="{'disabled': activeStepIndex === 1 && activeChapterIndex === 1}">
                            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="none" viewBox="0 0 14 14"> <g clip-path="url(#a)"> <path stroke="#fff" stroke-linecap="round" stroke-linejoin="round" d="m1.26 6.261 5.074-4.927a1.182 1.182 0 0 1 1.65.004l5.02 4.941M3.02 7.384v4.173c0 .655.53 1.182 1.178 1.182h1.76a1.18 1.18 0 0 0 1.178-1.182v-1.7m4.126-2.473v4.173a1.18 1.18 0 0 1-1.178 1.182h-1.08"/> </g> <defs> <clipPath id="a"> <rect width="14" height="14" fill="#fff" rx="4"/> </clipPath> </defs> </svg>
                        </li>
                        <li @click="prevStep" :class="{'disabled': activeStepIndex === 1 && activeChapterIndex === 1}">
                            <svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" fill="none" viewBox="0 0 9 9"> <path fill="#fff" d="M8.013 5.347H2.319L4.934 8.16l-.662.71L.53 4.846 4.27.82l.659.705-2.61 2.815h5.694v1.007Z"/> </svg>
                        </li>
                        <li @click="nextStep" :class="{'disabled': activeStepIndex === lastStepOfCurrentChapter && activeChapterIndex === lastChapter}">
                            <svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" fill="none" viewBox="0 0 9 9"> <path fill="#fff" d="M.872 3.654h5.694L3.95.839l.662-.71 3.741 4.026-3.74 4.025-.659-.705 2.61-2.814H.873V3.654Z"/> </svg>
                        </li>
                    </ul>

                    <div class="navigation-steps">
                        {{ activeStepIndex }} of {{ lastStepOfCurrentChapter }}
                    </div>

                    <ul class="navigation-lines">
                        <li v-for="(item, i) in chapters[activeChapterIndex - 1].steps" :key="i" :class="{'active': i+1 === activeStepIndex}" @click="goToStep(activeChapterIndex, i+1)">
                            <div class="placeholder">{{ item.name }}</div>
                        </li>
                    </ul>

                </div>

            </div>
        </div>

    </div>
</template>

<script>

    // LAYOUT

    import overview from '@/components/layout/Overview';

    // INTRODUCTION

    import introductionslide1 from '@/components/introduction/Slide1';
    import introductionslide2 from '@/components/introduction/Slide2';

    // CHAPTER 1

    import chapter1slide1 from '@/components/chapter-1/Slide1';
    import chapter1slide2 from '@/components/chapter-1/Slide2';
    import chapter1slide3 from '@/components/chapter-1/Slide3';
    import chapter1slide4 from '@/components/chapter-1/Slide4';

    // CHAPTER 2

    import chapter2slide1 from '@/components/chapter-2/Slide1';
    import chapter2slide2 from '@/components/chapter-2/Slide2';
    import chapter2slide3 from '@/components/chapter-2/Slide3';

    // CHAPTER 3

    import chapter3slide1 from '@/components/chapter-3/Slide1';
    import chapter3slide2 from '@/components/chapter-3/Slide2';
    import chapter3slide3 from '@/components/chapter-3/Slide3';
    import chapter3slide4 from '@/components/chapter-3/Slide4';
    import chapter3slide5 from '@/components/chapter-3/Slide5';

    // CHAPTER 4

    import chapter4slide1 from '@/components/chapter-4/Slide1';
    import chapter4slide2 from '@/components/chapter-4/Slide2';
    import chapter4slide3 from '@/components/chapter-4/Slide3';
    import chapter4slide4 from '@/components/chapter-4/Slide4';
    import chapter4slide5 from '@/components/chapter-4/Slide5';
    import chapter4slide6 from '@/components/chapter-4/Slide6';
    import chapter4slide7 from '@/components/chapter-4/Slide7';
    import chapter4slide8 from '@/components/chapter-4/Slide8';


    export default {
        name: 'HelloWorld',
        components: {

            overview,

            introductionslide1,
            introductionslide2,

            chapter1slide1,
            chapter1slide2,
            chapter1slide3,
            chapter1slide4,

            chapter2slide1,
            chapter2slide2,
            chapter2slide3,

            chapter3slide1,
            chapter3slide2,
            chapter3slide3,
            chapter3slide4,
            chapter3slide5,

            chapter4slide1,
            chapter4slide2,
            chapter4slide3,
            chapter4slide4,
            chapter4slide5,
            chapter4slide6,
            chapter4slide7,
            chapter4slide8

        },
        data() {
            return {
                activeChapterIndex: 1,
                activeStepIndex: 1,
                chapters: [{
                    name: 'Introduction',
                    steps: [{
                        name: 'Step 1',
                        component: 'introductionslide1'
                    },{
                        name: 'Step 2',
                        component: 'introductionslide2'
                    },{
                        name: 'Overview',
                        component: 'overview'
                    }]
                },{
                    name: 'Chapter 1',
                    steps: [{
                        name: 'step 1',
                        component: 'chapter1slide1'
                    },{
                        name: 'step 2',
                        component: 'chapter1slide2'
                    },{
                        name: 'step 3',
                        component: 'chapter1slide3'
                    },{
                        name: 'step 4',
                        component: 'chapter1slide4'
                    },{
                        name: 'Overview',
                        component: 'overview'
                    }]
                },{
                    name: 'Chapter 2',
                    steps: [{
                        name: 'step 1',
                        component: 'chapter2slide1'
                    },{
                        name: 'step 2',
                        component: 'chapter2slide2'
                    },{
                        name: 'step 3',
                        component: 'chapter2slide3'
                    },{
                        name: 'Overview',
                        component: 'overview'
                    }]
                },{
                    name: 'Chapter 3',
                    steps: [{
                        name: 'step 1',
                        component: 'chapter3slide1'
                    },{
                        name: 'step 2',
                        component: 'chapter3slide2'
                    },{
                        name: 'step 3',
                        component: 'chapter3slide3'
                    },{
                        name: 'step 4',
                        component: 'chapter3slide4'
                    },{
                        name: 'step 5',
                        component: 'chapter3slide5'
                    },{
                        name: 'overview',
                        component: 'overview'
                    }]
                },{
                    name: 'Chapter 4',
                    steps: [{
                        name: 'step 1',
                        component: 'chapter4slide1'
                    },{
                        name: 'step 2',
                        component: 'chapter4slide2'
                    },{
                        name: 'step 3',
                        component: 'chapter4slide3'
                    },{
                        name: 'step 4',
                        component: 'chapter4slide4'
                    },{
                        name: 'step 5',
                        component: 'chapter4slide5'
                    },{
                        name: 'step 6',
                        component: 'chapter4slide6'
                    },{
                        name: 'step 7',
                        component: 'chapter4slide7'
                    },{
                        name: 'step 8',
                        component: 'chapter4slide8'
                    }]
                }]
            }
        },
        computed: {
            totalSteps() {

                let countNumberOfSteps = 0;

                this.chapters.forEach(element => {
                    countNumberOfSteps = countNumberOfSteps + element.steps.length;
                });

                return countNumberOfSteps;

            },
            totalChapters() {
                return this.chapters.length;
            },
            activeChapter() {
                return this.chapters[this.activeChapterIndex - 1];
            },
            activeStep() {
                return this.activeChapter.steps[this.activeStepIndex - 1];
            },
            lastStepOfCurrentChapter() {
                return this.chapters[this.activeChapterIndex - 1].steps.length;
            },
            lastChapter() {
                return this.chapters.length;
            },
            transitionType() {
                return (this.activeStep.component === 'overview') ? 'slideup' : 'fade';
            }
        },
        methods: {
            prevStep() {

                if( this.activeStepIndex > 1) {

                    this.activeStepIndex --;

                } else if( this.activeChapterIndex > 1 ) {

                    this.activeChapterIndex --;
                    this.activeStepIndex = this.activeChapter.steps.length;

                }

            },
            nextStep() {

                if( this.activeStepIndex < this.activeChapter.steps.length ) {

                    this.activeStepIndex ++;

                } else if ( this.activeChapterIndex < this.chapters.length ) {

                    this.activeChapterIndex ++;
                    this.activeStepIndex = 1;

                }

            },
            goToStep(chapter, step) {

                this.activeChapterIndex = chapter;
                this.activeStepIndex = step;

            },
        },
        mounted() {

            document.addEventListener('keydown', e => {

                if (e.key === 'ArrowRight') this.nextStep();
                if (e.key === 'ArrowLeft') this.prevStep();

            }, false);

        },
    }

</script>

<style lang="scss">

    @import '~@/assets/scss/main.scss';

    ul.subnav {
        background: white;
        border-radius: 4px;
        position: absolute;
        top: 20px;
        left: 20px;
        right: 20px;
        display: flex;
        align-items: flex-end;
        padding: 0 80px;

        li {
            border-bottom: 3px solid transparent;
            flex: 1 0 auto;
            padding: 20px 0;
            margin: 0 20px;
            text-align: center;
            cursor: pointer;
            position: relative;

            &.active { border-color: $color-blue; color: $color-blue; font-weight: 500; }
        }

        @include custom-breakpoint(1000) {
            display: none;
        }
    }

    .navbar {
        background: white;
        border-radius: 4px;
        position: absolute;
        bottom: 30px;
        left: 30px;
        right: 30px;
        display: flex;
        align-items: center;
        padding: 10px 20px 10px 12px;
        z-index: 1;

        ul.navigation-buttons {
            flex: 0 1 auto;
            display: flex;

            > li {
                background: #005AFF;
                background-repeat: no-repeat;
                background-position: center center;
                border-radius: 4px;
                width: 30px;
                height: 30px;
                cursor: pointer;
                display: flex;
                align-items: center;
                justify-content: center;
                user-select: none;

                &:first-child {
                    background: #001135;
                }

                &:nth-child(2):after { transform: rotate(135deg); right: -1px; }

                img { max-width: 50%; }

                &:not(:first-child):hover:not(.disabled) { background-color: darken(#005AFF, 10); }

                &.disabled { opacity: .5; cursor: default; }

                &:nth-child(2) { margin: 0 10px; }
            }
        }

        .navigation-steps {
            flex: 0 1 auto;
            margin: 0 40px;
            font-weight: 500;
        }

        ul.navigation-lines {
            flex: 1 0 auto;
            display: flex;
            margin: 0 -10px;

            li {
                cursor: pointer;
                flex: 1 0 auto;
                margin: 0 10px;
                height: 20px;
                display: flex;
                align-items: center;
                position: relative;

                .placeholder {
                    background: lighten(#858585, 10);
                    border-radius: 6px;
                    position: absolute;
                    left: 50%;
                    display: none;
                    bottom: 24px;
                    text-align: center;
                    transform: translate(-50%, 0);
                    padding: 4px 10px;
                    color: white;

                    &:after {
                        border-left: 6px solid transparent;
                        border-right: 6px solid transparent;
                        border-top: 6px solid lighten(#858585, 10);
                        width: 0;
                        height: 0;
                        position: absolute;
                        bottom: -6px;
                        left: 50%;
                        transform: translate(-50%, 0);
                        content: '';
                    }
                }

                &:after {
                    background: #001135;
                    height: 3px;
                    display: block;
                    width: 100%;
                    content: '';
                }

                &.active:after {
                    background: #005AFF;
                }

                &:hover {

                    .placeholder { display: block; }
                    &:not(.active):after { background: lighten(#858585, 10); }
                }
            }

        }

        @include custom-breakpoint(1000) {
            justify-content: space-between;

            ul.navigation-lines {
                display: none;
            }
        }
    }



    // TEMP

    .button-holder {

        button {
            background: mediumaquamarine;
            padding: 4px 10px;

            + button { margin-left: 10px; }
        }
    }

    .info-holder {
        background: #efefef;
        margin-bottom: 20px;
        padding: 20px;
        position: absolute;
        right: 190px;
        top: 20px;
        z-index: 2;
        display: none;
    }

    .chapter-holder {
        background: #efefef;
        position: absolute;
        top: 20px;
        right: 20px;
        padding: 20px;
        z-index: 2;
        opacity: 0;
        // display: none;

        &:hover {
            opacity: 1;
        }

        .chapters {
            margin-bottom: 20px;

            p {
                margin-bottom: 6px;
                cursor: pointer;

                &:hover {
                    color: mediumaquamarine;
                }
            }

            ul > li {
                cursor: pointer;

                &:hover {
                    color: mediumaquamarine;
                }
            }

            &.active {

                p { color: red; }

                > li { font-weight: normal; }

                ul > li { font-weight: 300; }

                .active { color: red; }
            }
        }
    }

</style>